import { render, staticRenderFns } from "./AboutGestalt.vue?vue&type=template&id=50bde9da&"
import script from "./AboutGestalt.vue?vue&type=script&lang=ts&"
export * from "./AboutGestalt.vue?vue&type=script&lang=ts&"
import style0 from "./AboutGestalt.vue?vue&type=style&index=0&id=50bde9da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports